import { Pagination } from 'swiper';
import { SwiperSlide } from 'swiper/react';

import { Field, ImageField, LinkField, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { ExtendedItem } from 'src/types/ExtendedItem';

import { SwiperComponent, SwiperSlideComponent } from 'src/components/basicContent/_Swiper/Swiper';

import styles from './GroupImageCallToAction.module.css';

type GroupImageCallToActionProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		CallToActions: [
			ExtendedItem & {
				fields: {
					Image: ImageField;
					Title: Field<string>;
					Description: Field<string>;
					Link: LinkField;
					Logo: ImageField;
				};
			}
		];
		EnableTransparentBackground: Field<boolean>;
	};
};

export default withDatasourceCheck()<GroupImageCallToActionProps>(GroupImageCallToAction);

function GroupImageCallToAction(props: GroupImageCallToActionProps): JSX.Element {
	const callToActions = props.fields.CallToActions;

	return (
		<section className={`${styles.section} ${!props.fields.EnableTransparentBackground?.value ? styles.background : ''} cen`}>
			<Text tag="h2" field={props.fields.Title} className={styles.title} />

			{callToActions && (
				<SwiperComponent
					modules={[Pagination]}
					pagination={{
						clickable: true,
					}}
					spaceBetween={15}
					slidesPerView={callToActions.length > 1 ? 1.075 : 1}
					breakpoints={{
						500: {
							slidesPerView: callToActions.length < 3 ? 2 : 2.075,
						},
						800: {
							slidesPerView: 3,
						},
					}}
					centerInsufficientSlides={true}
					className={`${styles.slider} maxWidth`}
				>
					{callToActions.map((slide, index) => (
						<SwiperSlide className={`${styles.slide} ${styles.background} rounded`} key={index}>
							<SwiperSlideComponent
								media={slide.fields.Image}
								title={slide.fields.Title}
								description={slide.fields.Description}
								link={slide.fields.Link}
								logo={slide.fields.Logo}
								buttonColor="white"
							/>
						</SwiperSlide>
					))}
				</SwiperComponent>
			)}
		</section>
	);
}
